import {SERVICE_TYPES} from 'Core/serviceTypes';
import {reverseGeocodeModel} from '../../model/reverseGeocode/reverseGeocode';
import {batchModel} from '../../model/reverseGeocode/batchReverseGeocode';
import {addFields} from '../utils';
import {modelResponse} from '../../model/modelResponse';
import { Endpoints } from '../../endpoints/endpointsManager';
import {
    singleRequestServiceFactory, batchRequestServiceFactory, serviceFactory
} from '../../core';

const TYPES = {
    reverseGeocode: 'reverseGeocode',
    crossStreetLookup: 'reverseGeocode/crossStreet'
};

function ReverseGeocodeBase(options, additionalOptions) {
    this.options = options;
    this.additionalOptions = additionalOptions;
    this.fields = {};
}

ReverseGeocodeBase.prototype.TYPE = TYPES;
ReverseGeocodeBase.prototype.construct = function(serviceName) {
    const mergedFields = addFields(this.fields, this.defaultFields);

    const service = serviceFactory(
        mergedFields,
        SERVICE_TYPES.SEARCH,
        serviceName || 'reverseGeocodeBase',
        this.handleServiceCall.bind(this),
        this.handleBatchServiceCall.bind(this)
    );

    return service(this.options, this.additionalOptions);

};
ReverseGeocodeBase.prototype.handleServiceCall = function(data, abortSignal) {
    const endpoints = new Endpoints(this.additionalOptions);
    const singleRequest = singleRequestServiceFactory(endpoints.resolve('reverseGeocodeEndpoint'));
    return singleRequest(this.fields, data, abortSignal)
        .then(response => modelResponse(response, reverseGeocodeModel));
};

ReverseGeocodeBase.prototype.handleBatchServiceCall = function(data, abortSignal) {
    const endpoints = new Endpoints(this.additionalOptions);
    const batchRequest = batchRequestServiceFactory(100, {
        single: endpoints.resolve('batchReverseGeocodeQueryEndpoint'),
        batch: endpoints.resolve('batchSearchEndpoint'),
        batchSync: endpoints.resolve('batchSyncSearchEndpoint')
    });
    return batchRequest(this.fields, data, abortSignal)
        .then(response => modelResponse(response, batchModel));
};

function reverseGeocodeConstructor(options) {
    return (new ReverseGeocodeBase(options)).construct();
}

reverseGeocodeConstructor.prototype.constructor = ReverseGeocodeBase;

export {reverseGeocodeConstructor as reverseGeocodeBase};
